export default __webpack_public_path__ + "static/media/Can-I-Eat-It-Screenshot.de144ba3.png";